"use strict";
// @ts-ignore
try {
    self['workbox:window:6.4.1'] && _();
}
catch (e) { }
